import { normalizePlanSlug, type SubscriptionPlanDefinition } from "@/domains/subscription/plans";
import {
    fetchSubscriptionPlans,
    mapBenefits,
} from "@/domains/subscription/subscriptionPlansApi";
import { useQuery } from "@tanstack/react-query";

export const subscriptionPlansQueryKey = ["billing", "plans"] as const;

function mapApiPlan(
    plan: Awaited<ReturnType<typeof fetchSubscriptionPlans>>[number],
): SubscriptionPlanDefinition {
    const slug = normalizePlanSlug(plan.id);
    return {
        id: slug,
        versionId: plan.versionId,
        name: plan.name,
        patientLimit: plan.patientLimit,
        storageLimitBytes: plan.storageLimitBytes,
        priceLabel: plan.priceLabel,
        periodLabel: plan.periodLabel,
        priceBrl: plan.priceBrl,
        benefits: mapBenefits(plan.benefits),
        description: plan.description,
        cta: plan.cta,
        enabled: plan.enabled,
        trialDays: plan.trialDays,
    };
}

export function useSubscriptionPlans() {
    return useQuery({
        queryKey: subscriptionPlansQueryKey,
        queryFn: async () => {
            const plans = await fetchSubscriptionPlans();
            return plans.map(mapApiPlan);
        },
        staleTime: 60_000,
    });
}
